<div class="card">
  <div id="tableOfContents" style="padding: 1rem;">
    <div class="flex" style="justify-content: space-between;">
      <h1 class="webapp-title">Lo que vas a encontrar aquí</h1>
      <i *ngIf="status=='show'" class="fas fa-chevron-up pointer" (click)="changeStatus()"></i>
      <i *ngIf="status=='hidden'" class="fas fa-chevron-down pointer" (click)="changeStatus()"></i>
    </div>
    <span *ngIf="readMore && status=='show'">
      <ul class="none">
        <li *ngFor="let section of sections"> <!-- *ngIf="section.visible" -->
          <a href="javascript: void(0)" (click)="select(section)">{{ getTitle(section.data) }}</a>
        </li>
      </ul>
      <span class="small-light button-text" (click)="showMore()">Leer menos</span>
    </span>

    <span *ngIf="!readMore && status=='show'">
      <ul class="none">
        <li *ngFor="let op of getOptions()">
          <a href="javascript: void(0)" (click)="select(op)" >{{ op.data.title }}</a>
        </li>
      </ul>
      <span class="read-more-text" *ngIf="!readMore"  (click)="showMore()">Leer más</span>
    </span>
  </div>
</div>